import { useTrans } from '../../../services/i18n'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { Paper, SpacingContainer } from '../../../components/common/Containers'
import Item from './Item'

export default function AdminEventList({ items }) {
  const { trans } = useTrans()
  const list = Array.isArray(items) ? items : []

  return (
    <TableContainer component={Paper} radius={9}>
      <SpacingContainer px='5sm3' py={2}>
        <Table style={{ minWidth: 800 }}>
          <TableHead>
            <TableRow>
              <TableCell align='left'>{trans('date')}</TableCell>
              {/* <TableCell align='left'>{trans('admin')}</TableCell> */}
              <TableCell align='left'>{trans('description')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list.length === 0 ? (
              <TableRow>
                <TableCell align='left' colSpan={2}>
                  {trans('no_results') || trans('no_data')}
                </TableCell>
              </TableRow>
            ) : (
              list.map((evt, idx) => (
                <Item key={evt?.id || evt?._id || idx} event={evt} />
              ))
            )}
          </TableBody>
        </Table>
      </SpacingContainer>
    </TableContainer>
  )
}
